// Icônes Material Symbols Rounded (poids 400), en SVG embarqués : pas de police de 5 Mo,
// rien à charger hors du domaine (CSP). Ajouter une icône : l'importer ici et l'inscrire.

import iEco from '@material-symbols/svg-400/rounded/eco.svg?raw'
import iRocketLaunch from '@material-symbols/svg-400/rounded/rocket_launch.svg?raw'
import iFormatBold from '@material-symbols/svg-400/rounded/format_bold.svg?raw'
import iFormatItalic from '@material-symbols/svg-400/rounded/format_italic.svg?raw'
import iFormatStrikethrough from '@material-symbols/svg-400/rounded/format_strikethrough.svg?raw'
import iFormatListBulleted from '@material-symbols/svg-400/rounded/format_list_bulleted.svg?raw'
import iFormatListNumbered from '@material-symbols/svg-400/rounded/format_list_numbered.svg?raw'
import iFormatQuote from '@material-symbols/svg-400/rounded/format_quote.svg?raw'
import iFormatH1 from '@material-symbols/svg-400/rounded/format_h1.svg?raw'
import iFormatH2 from '@material-symbols/svg-400/rounded/format_h2.svg?raw'
import iCode from '@material-symbols/svg-400/rounded/code.svg?raw'
import iAddComment from '@material-symbols/svg-400/rounded/add_comment.svg?raw'
import iForum from '@material-symbols/svg-400/rounded/forum.svg?raw'
import iVisibilityOff from '@material-symbols/svg-400/rounded/visibility_off.svg?raw'
import iUndo from '@material-symbols/svg-400/rounded/undo.svg?raw'
import iRedo from '@material-symbols/svg-400/rounded/redo.svg?raw'
import iNoteAdd from '@material-symbols/svg-400/rounded/note_add.svg?raw'
import iSubdirectoryArrowRight from '@material-symbols/svg-400/rounded/subdirectory_arrow_right.svg?raw'
import iChatBubble from '@material-symbols/svg-400/rounded/chat_bubble.svg?raw'
import iHorizontalRule from '@material-symbols/svg-400/rounded/horizontal_rule.svg?raw'
import iRocketLaunchPlein from '@material-symbols/svg-400/rounded/rocket_launch-fill.svg?raw'
import iVisibility from '@material-symbols/svg-400/rounded/visibility.svg?raw'
import iSync from '@material-symbols/svg-400/rounded/sync.svg?raw'
import iSyncAlt from '@material-symbols/svg-400/rounded/sync_alt.svg?raw'
import iDateRange from '@material-symbols/svg-400/rounded/date_range.svg?raw'
import iHub from '@material-symbols/svg-400/rounded/hub.svg?raw'
import iBlock from '@material-symbols/svg-400/rounded/block.svg?raw'
import iSearchOff from '@material-symbols/svg-400/rounded/search_off.svg?raw'
import iFindInPage from '@material-symbols/svg-400/rounded/find_in_page.svg?raw'
import iProgressActivity from '@material-symbols/svg-400/rounded/progress_activity.svg?raw'
import iError from '@material-symbols/svg-400/rounded/error.svg?raw'
import iCheckCirclePlein from '@material-symbols/svg-400/rounded/check_circle-fill.svg?raw'
import iCancelPlein from '@material-symbols/svg-400/rounded/cancel-fill.svg?raw'
import iErrorPlein from '@material-symbols/svg-400/rounded/error-fill.svg?raw'
import iFolder from '@material-symbols/svg-400/rounded/folder.svg?raw'
import iCreateNewFolder from '@material-symbols/svg-400/rounded/create_new_folder.svg?raw'
import iDriveFileMove from '@material-symbols/svg-400/rounded/drive_file_move.svg?raw'
import iSmartToy from '@material-symbols/svg-400/rounded/smart_toy.svg?raw'
import iOpenInFull from '@material-symbols/svg-400/rounded/open_in_full.svg?raw'
import iCloseFullscreen from '@material-symbols/svg-400/rounded/close_fullscreen.svg?raw'
import iSend from '@material-symbols/svg-400/rounded/send.svg?raw'
import iStopCircle from '@material-symbols/svg-400/rounded/stop_circle.svg?raw'
import iMic from '@material-symbols/svg-400/rounded/mic.svg?raw'
import iRestartAlt from '@material-symbols/svg-400/rounded/restart_alt.svg?raw'
import iAutoAwesome from '@material-symbols/svg-400/rounded/star_shine.svg?raw'
import iEventRepeat from '@material-symbols/svg-400/rounded/event_repeat.svg?raw'
import iSchool from '@material-symbols/svg-400/rounded/school.svg?raw'
import iPersonAdd from '@material-symbols/svg-400/rounded/person_add.svg?raw'
import iFrontHand from '@material-symbols/svg-400/rounded/front_hand.svg?raw'
import iMoreHoriz from '@material-symbols/svg-400/rounded/more_horiz.svg?raw'
import iOpenInNew from '@material-symbols/svg-400/rounded/open_in_new.svg?raw'
import iLink from '@material-symbols/svg-400/rounded/link.svg?raw'
import iHealthAndSafety from '@material-symbols/svg-400/rounded/health_and_safety.svg?raw'
import iDomainDisabled from '@material-symbols/svg-400/rounded/domain_disabled.svg?raw'
import iWarning from '@material-symbols/svg-400/rounded/warning.svg?raw'
import iArrowUpward from '@material-symbols/svg-400/rounded/arrow_upward.svg?raw'
import iPlayArrow from '@material-symbols/svg-400/rounded/play_arrow.svg?raw'
import iTune from '@material-symbols/svg-400/rounded/tune.svg?raw'
import iKeyboardArrowUp from '@material-symbols/svg-400/rounded/keyboard_arrow_up.svg?raw'
import iAttachFile from '@material-symbols/svg-400/rounded/attach_file.svg?raw'
import iDownload from '@material-symbols/svg-400/rounded/download.svg?raw'
import iFolderZip from '@material-symbols/svg-400/rounded/folder_zip.svg?raw'
import iPictureAsPdf from '@material-symbols/svg-400/rounded/picture_as_pdf.svg?raw'
import iZoomIn from '@material-symbols/svg-400/rounded/zoom_in.svg?raw'
import iCall from '@material-symbols/svg-400/rounded/call.svg?raw'
import iNotifications from '@material-symbols/svg-400/rounded/notifications.svg?raw'
import iSmartphone from '@material-symbols/svg-400/rounded/mobile.svg?raw'
import iTouchApp from '@material-symbols/svg-400/rounded/touch_app.svg?raw'
import iAddTask from '@material-symbols/svg-400/rounded/add_task.svg?raw'
import iArrowBack from '@material-symbols/svg-400/rounded/arrow_back.svg?raw'
import iRule from '@material-symbols/svg-400/rounded/rule.svg?raw'
import iAccountTree from '@material-symbols/svg-400/rounded/account_tree.svg?raw'
import iLanguage from '@material-symbols/svg-400/rounded/language.svg?raw'
import iAutoAwesomePlein from '@material-symbols/svg-400/rounded/star_shine-fill.svg?raw'
import iPlayArrowPlein from '@material-symbols/svg-400/rounded/play_arrow-fill.svg?raw'
import iHome from '@material-symbols/svg-400/rounded/home.svg?raw'
import iTaskAlt from '@material-symbols/svg-400/rounded/task_alt.svg?raw'
import iChecklist from '@material-symbols/svg-400/rounded/checklist.svg?raw'
import iCalendarMonth from '@material-symbols/svg-400/rounded/calendar_month.svg?raw'
import iPayments from '@material-symbols/svg-400/rounded/payments.svg?raw'
import iAccountBalance from '@material-symbols/svg-400/rounded/account_balance.svg?raw'
import iDescription from '@material-symbols/svg-400/rounded/description.svg?raw'
import iDomain from '@material-symbols/svg-400/rounded/domain.svg?raw'
import iHandshake from '@material-symbols/svg-400/rounded/handshake.svg?raw'
import iGroup from '@material-symbols/svg-400/rounded/group.svg?raw'
import iContacts from '@material-symbols/svg-400/rounded/contacts.svg?raw'
import iFactCheck from '@material-symbols/svg-400/rounded/fact_check.svg?raw'
import iSettings from '@material-symbols/svg-400/rounded/settings.svg?raw'
import iLightMode from '@material-symbols/svg-400/rounded/light_mode.svg?raw'
import iDarkMode from '@material-symbols/svg-400/rounded/dark_mode.svg?raw'
import iContrast from '@material-symbols/svg-400/rounded/contrast.svg?raw'
import iLogout from '@material-symbols/svg-400/rounded/logout.svg?raw'
import iEventUpcoming from '@material-symbols/svg-400/rounded/event_upcoming.svg?raw'
import iSnooze from '@material-symbols/svg-400/rounded/snooze.svg?raw'
import iArrowForward from '@material-symbols/svg-400/rounded/arrow_forward.svg?raw'
import iEditNote from '@material-symbols/svg-400/rounded/edit_note.svg?raw'
import iEdit from '@material-symbols/svg-400/rounded/edit.svg?raw'
import iSchedule from '@material-symbols/svg-400/rounded/schedule.svg?raw'
import iHelp from '@material-symbols/svg-400/rounded/help.svg?raw'
import iCalendarToday from '@material-symbols/svg-400/rounded/calendar_today.svg?raw'
import iCallSplit from '@material-symbols/svg-400/rounded/call_split.svg?raw'
import iNorthEast from '@material-symbols/svg-400/rounded/north_east.svg?raw'
import iSouthWest from '@material-symbols/svg-400/rounded/south_west.svg?raw'
import iChevronRight from '@material-symbols/svg-400/rounded/chevron_right.svg?raw'
import iChevronLeft from '@material-symbols/svg-400/rounded/chevron_left.svg?raw'
import iRadioButtonUnchecked from '@material-symbols/svg-400/rounded/radio_button_unchecked.svg?raw'
import iClockLoader40 from '@material-symbols/svg-400/rounded/clock_loader_40.svg?raw'
import iHourglassTop from '@material-symbols/svg-400/rounded/hourglass_top.svg?raw'
import iCheckCircle from '@material-symbols/svg-400/rounded/check_circle.svg?raw'
import iPerson from '@material-symbols/svg-400/rounded/person.svg?raw'
import iViewKanban from '@material-symbols/svg-400/rounded/view_kanban.svg?raw'
import iViewList from '@material-symbols/svg-400/rounded/view_list.svg?raw'
import iViewWeek from '@material-symbols/svg-400/rounded/view_week.svg?raw'
import iEvent from '@material-symbols/svg-400/rounded/event.svg?raw'
import iKeyboardArrowDown from '@material-symbols/svg-400/rounded/keyboard_arrow_down.svg?raw'
import iFilterList from '@material-symbols/svg-400/rounded/filter_list.svg?raw'
import iViewTimeline from '@material-symbols/svg-400/rounded/view_timeline.svg?raw'
import iEventNote from '@material-symbols/svg-400/rounded/event_note.svg?raw'
import iDoneAll from '@material-symbols/svg-400/rounded/done_all.svg?raw'
import iCheck from '@material-symbols/svg-400/rounded/check.svg?raw'
import iUpload from '@material-symbols/svg-400/rounded/upload.svg?raw'
import iCsv from '@material-symbols/svg-400/rounded/csv.svg?raw'
import iLinkOff from '@material-symbols/svg-400/rounded/link_off.svg?raw'
import iHistory from '@material-symbols/svg-400/rounded/history.svg?raw'
import iUploadFile from '@material-symbols/svg-400/rounded/upload_file.svg?raw'
import iSearch from '@material-symbols/svg-400/rounded/search.svg?raw'
import iForwardToInbox from '@material-symbols/svg-400/rounded/forward_to_inbox.svg?raw'
import iReceiptLong from '@material-symbols/svg-400/rounded/receipt_long.svg?raw'
import iMail from '@material-symbols/svg-400/rounded/mail.svg?raw'
import iVerified from '@material-symbols/svg-400/rounded/verified.svg?raw'
import iComputer from '@material-symbols/svg-400/rounded/computer.svg?raw'
import iShield from '@material-symbols/svg-400/rounded/shield.svg?raw'
import iDraw from '@material-symbols/svg-400/rounded/draw.svg?raw'
import iStorefront from '@material-symbols/svg-400/rounded/storefront.svg?raw'
import iApartment from '@material-symbols/svg-400/rounded/apartment.svg?raw'
import iKey from '@material-symbols/svg-400/rounded/key.svg?raw'
import iFamilyHome from '@material-symbols/svg-400/rounded/family_home.svg?raw'
import iInventory2 from '@material-symbols/svg-400/rounded/inventory_2.svg?raw'
import iCalculate from '@material-symbols/svg-400/rounded/calculate.svg?raw'
import iPercent from '@material-symbols/svg-400/rounded/percent.svg?raw'
import iAdd from '@material-symbols/svg-400/rounded/add.svg?raw'
import iEventAvailable from '@material-symbols/svg-400/rounded/event_available.svg?raw'
import iClose from '@material-symbols/svg-400/rounded/close.svg?raw'
import iDelete from '@material-symbols/svg-400/rounded/delete.svg?raw'
import iCancel from '@material-symbols/svg-400/rounded/cancel.svg?raw'
import iPhotoCamera from '@material-symbols/svg-400/rounded/photo_camera.svg?raw'
import iOutbox from '@material-symbols/svg-400/rounded/outbox.svg?raw'
import iPhotoCameraPlein from '@material-symbols/svg-400/rounded/photo_camera-fill.svg?raw'
import iOutboxPlein from '@material-symbols/svg-400/rounded/outbox-fill.svg?raw'
import iCheckBox from '@material-symbols/svg-400/rounded/check_box.svg?raw'
import iEcoPlein from '@material-symbols/svg-400/rounded/eco-fill.svg?raw'
import iHomePlein from '@material-symbols/svg-400/rounded/home-fill.svg?raw'
import iTaskAltPlein from '@material-symbols/svg-400/rounded/task_alt-fill.svg?raw'
import iCalendarMonthPlein from '@material-symbols/svg-400/rounded/calendar_month-fill.svg?raw'
import iPaymentsPlein from '@material-symbols/svg-400/rounded/payments-fill.svg?raw'
import iAccountBalancePlein from '@material-symbols/svg-400/rounded/account_balance-fill.svg?raw'
import iDescriptionPlein from '@material-symbols/svg-400/rounded/description-fill.svg?raw'
import iDomainPlein from '@material-symbols/svg-400/rounded/domain-fill.svg?raw'
import iAccountTreePlein from '@material-symbols/svg-400/rounded/account_tree-fill.svg?raw'
import iHandshakePlein from '@material-symbols/svg-400/rounded/handshake-fill.svg?raw'
import iGroupPlein from '@material-symbols/svg-400/rounded/group-fill.svg?raw'
import iContactsPlein from '@material-symbols/svg-400/rounded/contacts-fill.svg?raw'
import iFactCheckPlein from '@material-symbols/svg-400/rounded/fact_check-fill.svg?raw'
import iSettingsPlein from '@material-symbols/svg-400/rounded/settings-fill.svg?raw'

const ICONES = {
  rocket_launch: iRocketLaunch,
  format_bold: iFormatBold,
  format_italic: iFormatItalic,
  format_strikethrough: iFormatStrikethrough,
  format_list_bulleted: iFormatListBulleted,
  format_list_numbered: iFormatListNumbered,
  format_quote: iFormatQuote,
  format_h1: iFormatH1,
  format_h2: iFormatH2,
  code: iCode,
  add_comment: iAddComment,
  forum: iForum,
  visibility_off: iVisibilityOff,
  undo: iUndo,
  redo: iRedo,
  note_add: iNoteAdd,
  subdirectory_arrow_right: iSubdirectoryArrowRight,
  chat_bubble: iChatBubble,
  horizontal_rule: iHorizontalRule,
  eco: iEco,
  home: iHome,
  task_alt: iTaskAlt,
  checklist: iChecklist,
  calendar_month: iCalendarMonth,
  payments: iPayments,
  account_balance: iAccountBalance,
  description: iDescription,
  domain: iDomain,
  handshake: iHandshake,
  group: iGroup,
  contacts: iContacts,
  fact_check: iFactCheck,
  settings: iSettings,
  light_mode: iLightMode,
  dark_mode: iDarkMode,
  contrast: iContrast,
  logout: iLogout,
  event_upcoming: iEventUpcoming,
  snooze: iSnooze,
  arrow_forward: iArrowForward,
  edit_note: iEditNote,
  edit: iEdit,
  schedule: iSchedule,
  help: iHelp,
  calendar_today: iCalendarToday,
  call_split: iCallSplit,
  north_east: iNorthEast,
  south_west: iSouthWest,
  chevron_right: iChevronRight,
  chevron_left: iChevronLeft,
  radio_button_unchecked: iRadioButtonUnchecked,
  clock_loader_40: iClockLoader40,
  hourglass_top: iHourglassTop,
  check_circle: iCheckCircle,
  person: iPerson,
  view_kanban: iViewKanban,
  view_list: iViewList,
  view_week: iViewWeek,
  event: iEvent,
  keyboard_arrow_down: iKeyboardArrowDown,
  filter_list: iFilterList,
  view_timeline: iViewTimeline,
  event_note: iEventNote,
  done_all: iDoneAll,
  check: iCheck,
  upload: iUpload,
  csv: iCsv,
  link_off: iLinkOff,
  history: iHistory,
  upload_file: iUploadFile,
  search: iSearch,
  forward_to_inbox: iForwardToInbox,
  receipt_long: iReceiptLong,
  mail: iMail,
  verified: iVerified,
  computer: iComputer,
  shield: iShield,
  draw: iDraw,
  storefront: iStorefront,
  apartment: iApartment,
  key: iKey,
  family_home: iFamilyHome,
  inventory_2: iInventory2,
  calculate: iCalculate,
  percent: iPercent,
  add: iAdd,
  event_available: iEventAvailable,
  close: iClose,
  delete: iDelete,
  cancel: iCancel,
  check_box: iCheckBox,
  photo_camera: iPhotoCamera,
  outbox: iOutbox,
  folder: iFolder,
  create_new_folder: iCreateNewFolder,
  drive_file_move: iDriveFileMove,
  smart_toy: iSmartToy,
  open_in_full: iOpenInFull,
  close_fullscreen: iCloseFullscreen,
  send: iSend,
  stop_circle: iStopCircle,
  mic: iMic,
  restart_alt: iRestartAlt,
  auto_awesome: iAutoAwesome,
  event_repeat: iEventRepeat,
  school: iSchool,
  person_add: iPersonAdd,
  front_hand: iFrontHand,
  more_horiz: iMoreHoriz,
  open_in_new: iOpenInNew,
  link: iLink,
  health_and_safety: iHealthAndSafety,
  domain_disabled: iDomainDisabled,
  warning: iWarning,
  arrow_upward: iArrowUpward,
  play_arrow: iPlayArrow,
  tune: iTune,
  keyboard_arrow_up: iKeyboardArrowUp,
  attach_file: iAttachFile,
  download: iDownload,
  folder_zip: iFolderZip,
  picture_as_pdf: iPictureAsPdf,
  zoom_in: iZoomIn,
  call: iCall,
  notifications: iNotifications,
  smartphone: iSmartphone,
  touch_app: iTouchApp,
  add_task: iAddTask,
  arrow_back: iArrowBack,
  rule: iRule,
  account_tree: iAccountTree,
  language: iLanguage,
  visibility: iVisibility,
  sync: iSync,
  sync_alt: iSyncAlt,
  date_range: iDateRange,
  hub: iHub,
  block: iBlock,
  search_off: iSearchOff,
  find_in_page: iFindInPage,
  progress_activity: iProgressActivity,
  error: iError,
}

const PLEINES: Partial<Record<NomIcone, string>> = {
  rocket_launch: iRocketLaunchPlein,
  eco: iEcoPlein,
  home: iHomePlein,
  task_alt: iTaskAltPlein,
  calendar_month: iCalendarMonthPlein,
  payments: iPaymentsPlein,
  account_balance: iAccountBalancePlein,
  description: iDescriptionPlein,
  domain: iDomainPlein,
  handshake: iHandshakePlein,
  group: iGroupPlein,
  contacts: iContactsPlein,
  fact_check: iFactCheckPlein,
  settings: iSettingsPlein,
  photo_camera: iPhotoCameraPlein,
  outbox: iOutboxPlein,
  auto_awesome: iAutoAwesomePlein,
  play_arrow: iPlayArrowPlein,
  account_tree: iAccountTreePlein,
  check_circle: iCheckCirclePlein,
  cancel: iCancelPlein,
  error: iErrorPlein,
}

export type NomIcone = keyof typeof ICONES

/** Icône décorative (aria-hidden) ; `plein` pour la variante remplie quand elle existe. */
export function Icone({
  nom,
  plein = false,
  taille,
  className,
}: {
  nom: NomIcone
  plein?: boolean
  taille?: number
  className?: string
}) {
  const svg = (plein && PLEINES[nom]) || ICONES[nom]
  return (
    <span
      aria-hidden="true"
      className={className ? `icone ${className}` : 'icone'}
      style={taille ? { fontSize: taille } : undefined}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
